/**
 * Decides whether to show the Russian "message appendix" banner. Replaces the
 * original's `XMLHttpRequest` to httpbin.org with `navigator.language(s)`.
 */

interface LanguageStore {
  getBrowserLanguage(): string | null;
  setBrowserLanguage(language: string): void;
}

const SUPPORTED_LANGUAGES = ["ru"];

/** Returns the first supported primary language subtag found, or null. */
export function matchLanguage(
  supported: readonly string[],
  languages: readonly string[],
): string | null {
  for (const language of languages) {
    const primary = language.toLowerCase().split("-")[0];
    if (primary && supported.includes(primary)) return primary;
  }
  return null;
}

function detectLanguages(): string[] {
  if (navigator.languages?.length) return [...navigator.languages];
  return navigator.language ? [navigator.language] : [];
}

/**
 * Whether the localized appendix should be shown. Caches the detected language
 * in storage (same `browserLanguage` key as the original) on first run.
 */
export function shouldDisplayAppendix(store: LanguageStore): boolean {
  if (store.getBrowserLanguage() === null) {
    const primary = navigator.language || "";
    if (primary) store.setBrowserLanguage(primary);
  }
  return matchLanguage(SUPPORTED_LANGUAGES, detectLanguages()) !== null;
}
